import { createBrowserRouter, RouterProvider }  from 'react-router-dom';
import { LayoutLogin } from './layouts/Login/LayoutLogin';
import { LayoutDashboard } from './layouts/Dashboard/LayoutDashboard';
import packageInfo from '../package.json';
import MyCacheBuster from './utils/Helpers/MyCacheBuster';
// Views
import { Login } from './pages/Login/Login';
import { ActivitiesPage } from './pages/Activities/ActivitiesPage';
import { Companies } from './pages/Companies/Companies';
import { Contacts } from './pages/Contacts/Contacts';
import { Orders } from './pages/Orders/Orders';
import { AccountPage } from './pages/Account/AccountPage';
import { ResetPassword } from './pages/Account/ResetPassword';

const version = packageInfo.version;

const router = createBrowserRouter([
  {
    path:"/",
    element: <LayoutLogin version={version}><Login/></LayoutLogin>
  },
  {
    path: "/activities",
    element: <LayoutDashboard version={version}><ActivitiesPage /></LayoutDashboard>
  },
  {
    path:"/companies",
    element: <LayoutDashboard version={version}><Companies/></LayoutDashboard>
  },
  {
    path:"/contacts",
    element: <LayoutDashboard version={version}><Contacts/></LayoutDashboard>
  },
  {
    path:"/orders",
    element: <LayoutDashboard version={version}><Orders/></LayoutDashboard>
  },
  {
    path:"/account",
    element: <LayoutDashboard version={version}><AccountPage/></LayoutDashboard>
  },
  {
    path: "/reset-password",
    element: <LayoutLogin version={version}><ResetPassword /></LayoutLogin>
  }
])

export const App = () => {
  const isProduction = process.env.NODE_ENV === 'production';
  return (
    <>
      <MyCacheBuster
        currentVersion={version}
        isEnabled={isProduction} //If false, the library is disabled.
        isVerboseMode={true} //If true, the library writes verbose logs to console.
        reloadOnDowngrade={true}
      >
        <RouterProvider
          router={router}
        />
      </MyCacheBuster>
    </>
  );
};